import React, { useCallback, useContext } from 'react';
import c from 'classnames';
import FallbackEditor from '../../DaEditorWrapper/Fallback';
import { CommentEditorContext, EditorContext } from '../context';
import s from './CommentFallbackEditor.scss';
var CommentFallbackEditor = function (_a) {
    var initialContent = _a.initialContent, onChange = _a.onChange, className = _a.className;
    var setIsFallbackEmpty = useContext(CommentEditorContext).setIsFallbackEmpty;
    var _b = useContext(EditorContext), overrideEditorState = _b.overrideEditorState, onEditorInit = _b.props.onEditorInit;
    var handleChange = useCallback(function (editorState) {
        setIsFallbackEmpty(editorState.isEmpty);
        // Because we're faking the editor state inside our fallback editor, we need to override the editor
        // state in the context.
        overrideEditorState(editorState);
        onChange && onChange(editorState);
    }, [onChange, setIsFallbackEmpty, overrideEditorState]);
    return (React.createElement(FallbackEditor, { className: c(s['root'], className), value: initialContent, onChange: handleChange, onReady: onEditorInit }));
};
CommentFallbackEditor.displayName = 'CommentFallbackEditor';
export default CommentFallbackEditor;
//# sourceMappingURL=CommentFallbackEditor.js.map